import React from "react";
import type { HTMLProps, ReactNode } from "react";
import { Helmet } from "react-helmet";

interface PageProps extends HTMLProps<HTMLDivElement> {
  children?: ReactNode;
  title?: string;
}

const Page = ({ children, title, ...rest }: PageProps) => {
  return (
    <div
      {...rest}
      data-iframe-height="" // Used for Iframe resizer heightCalculationMethod: 'taggedElement',
    >
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </div>
  );
};

export default Page;
